import { combineReducers } from 'redux'
import activityDetail from './activityDetailReducer'
import userInfo from './userInfoReducer'

export default combineReducers({
    userInfo,
    activityDetail
})
